<template>
     <div class="row mx-0 justify-content-center">
    
       <div class="col-lg-6 text-center  col-lg-6 col-md-6 col-10 pt-2 login-img">
        <a class="llp-logo" href="/">
          <img :alt="Logo" :aria-label="Logo" src="/images/makbilllogo.png" class="img-fluid1" />
        </a>
      </div>
        <div class="col-lg-6  col-md-6 col-sm-6  d-flex justify-content-center align-items-center">
    <form class="d-grid" @submit.prevent="doSetupPassword">
               <div class="row justify-content-center p-2">
                  <h4 class="otp-heading">Setup Password</h4>
                
                                <llp-label id="password-label"
                                           :aria-label="PASSWORD">
                                           Password:
                                </llp-label>
                                <llp-input id="password"
                                           v-model:modelValue="credential.password"
                                           :errors="validator.credential.password.$errors"
                                           type="password">
                                </llp-input>
                            </div>
                            <div class="row justify-content-center p-2">
                                <llp-label id="confirm-password-label" :aria-label="confirm_password">
                                  Confirm Password:
                                </llp-label>
                                <llp-input id="confirm-password" v-model:modelValue="credential.confirmPassword"
                                           :errors="validator.credential.confirmPassword.$errors" type="password">
                                </llp-input>
                            </div>
                            <div class="row justify-content-center p-2">
                                <div class="col-auto">
                                    <llp-button :loadSpinner="showSpinner" classNames="btn-secondary new-btn"
                                                type="submit">
                                                Setup Password
                                    </llp-button>
                                </div>
                            </div>
              <!-- <div class="row justify-content-center p-2">
                <llp-button
                  classNames="btn-link text-decoration-none new-btn"
                  type="button"
                  @click:button="goToLogin"
                >
                  Back to Login
                </llp-button>
              </div> -->
            </form>
   </div>
    </div>
   
    <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { helpers, required,sameAs} from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import ErrorService from '../../services/error.service';
import NetworkService from '../../services/network.service';
export default {
           setup: () => ({validator: useVuelidate()}),
  data() {
    return {
      credential: {
        password: '',
         email:'',
        confirmPassword: '',
      },
      token: '',
      userId:'',
     
      messages: [],
      showSpinner: false,
    };
  },
  validations() {
    return {
      credential: {
        password: {required: helpers.withMessage("Password is required.", required)},
        confirmPassword: {
          required: helpers.withMessage("confirm password is required.", required),
          sameAsNewPassword: helpers.withMessage("Confirm passwords do not match with password",
              sameAs(this.credential.password)),
        },
      },
    };
  },
  methods: {
    doSetupPassword() {
      this.validator
          .$validate()
          .then((isValid) => {
            if (!isValid) return Promise.reject();

            this.showSpinner = true;
            const data = {
               email: this.credential.email,
              password: this.credential.password,
              password_confirmation:this.credential.confirmPassword,
              token: this.token,
            };
            return NetworkService.post('/password-set', data);
          })
          .then((response) => {
             this.$refs.toast.show(response.data.message);
            
            // setTimeout(() => {
            //   this.$router.push('/document-verification');
            // }, 3000);
             setTimeout(() => {
               this.$router.push({
                name: "document-verification",
                query: {
                  id: response.data.id,
                  token: response.data.token,
                },
              });
             }, 2000);
          })
          .catch((error) => {
            this.$refs.toast.show(ErrorService.getErrorMessages(error), 'error');
          })
          .finally(() => {
            this.showSpinner = false;
          });
    },
  },
  mounted() {
    const paths = window.location.pathname.split('/');
    this.token = paths[paths.length - 2];
     this.credential.email = decodeURIComponent(paths[paths.length - 1]);
  },
};
</script>
